module.exports = __webpack_public_path__ + "media/hp-win-case.96dc29a1.mp3";